import { render, staticRenderFns } from "./SupplyCommodity_query.vue?vue&type=template&id=7e60aa0e&scoped=true"
import script from "./SupplyCommodity_query.vue?vue&type=script&lang=js"
export * from "./SupplyCommodity_query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e60aa0e",
  null
  
)

export default component.exports